import { List } from 'immutable';

import Role from 'entities/role/model';
import { RoleCode } from 'generated/graphql';

export const flattenUserRoles = (userRoles?: Role[] | List<Role>): Role | undefined => {
  if (!userRoles) {
    return undefined;
  }
  // @NOTE-DP: it's 2024 and I don't want to be wrestling with Immutable, really
  const userRolesRaw = ('toJS' in userRoles ? userRoles.toJS() : userRoles) as Role[];
  const ownerRole = userRolesRaw?.find((role) => role?.code === RoleCode.Owner);
  if (ownerRole) {
    return ownerRole;
  }
  return userRolesRaw?.[0] || undefined;
};
